// @flow
import React, { Component } from "react";
import md5 from "md5";
import type{ UserType } from "../types/UserType";

import Avatar from "@material-ui/core/Avatar";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

type UserAvatarStatesType = {
  avatar: string
};

type UserAvatarPropsType = {
  user: UserType
};

class UserAvatar extends Component<UserAvatarPropsType, UserAvatarStatesType> {
  constructor(props: UserAvatarPropsType) {
    super(props);
    this.state = {
      avatar: ""
    };
  }

  getGravtar = async (): * => {
    const user = this.props.user;
    const email = user.email;
    let img = "";
    if (email !== undefined) {
      img = md5(email.trim().toLowerCase());
    }
    const res: Response = await fetch(`https://www.gravatar.com/avatar/${img}?d=404`, { method: "GET" });
    if (res.ok) {
      this.setState({ avatar: `https://www.gravatar.com/avatar/${img}?s=256` });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.getGravtar();
    }, 500);
  }

  render(): React$Element<*> {
    if (this.state.avatar === "") {
      return (
        <Avatar
          alt="Default Avatar"
          className="avatar-img">
          <AccountCircleIcon className="avatar-icon" />
        </Avatar>
      );
    }
    else {
      return (
        <Avatar
          alt="Gravatar Image"
          src={this.state.avatar}
          className="avatar-img"
        />
      );
    }
  }
}

export default UserAvatar;